export default {"src":"/_next/static/media/icon-pulse-chart.6cc70371.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};